import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { apiURL } from "../../../../config/default";
import axios from "axios";
import { Button, Form, FormLabel } from "react-bootstrap";
let cancelName;

const UpdateFilterName = ({ setEdit, edit }) => {
  const dispatch = useDispatch();
  const [name, setName] = useState(edit?.name)

  const hanldeChangeName = async () => {

    if (typeof cancelName != typeof undefined) {
      cancelName.cancel("Operation canceled due to new request.");
    }

    cancelName = axios.CancelToken.source();

    const data = { name: name, _id: edit.id };
    const _config = {
      cancelToken: cancelName.token,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${apiURL}filters/update-name`,
        data,
        _config
      );
      if (res.status === 200) {
        setEdit({
          open: false,
          edit: "",
          title: "",
        });
        dispatch({
          type: "UPDATE_FILTER_NAME",
          payload: res.data,
        });
      }
    } catch (err) {
      // const errors = err.response.data.error;
    }
  };
  return (
    <div className="px-1">

      <Form.Group
        controlId={edit.id}
        style={{ width: "60%", margin: "0 auto" }}
      // onClick={() => seteditableIndex(id)}
      >
        <FormLabel>Enter Name</FormLabel>
        <Form.Control
          type="text"
          placeholder="Enter Name"
          // autoFocus
          // onBlur={() => seteditableIndex(null)}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <Button className="btn btn-dark btn-sm mt-3 btn-full" onClick={() => hanldeChangeName()}>Update</Button>
      </Form.Group>
    </div>
  );
};

export default UpdateFilterName;
